import React from 'react'

import { FSDeclineButtons, FSEndButtons, FSMainButtons } from '@components'
import { BonusSystemState, BonusSystemDeclineState } from 'game-ui-types'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'
import FSViewOptionsButtons from './FSViewOptionsButtons'
import { showFlexiBundles } from '@amusnet/react-ui'
import { FreeSpinsBonus } from '@amusnet/mgs-ws-client'

interface FSFooterProps {
    bonus?: FreeSpinsBonus
}

const FSFooter: React.FC<FSFooterProps> = ({ bonus }: FSFooterProps) => {
    const bonusSystemState = useFreeSpinsBonusesStore((state) => state.bonusSystemState)
    const bonusSystemDeclineState = useFreeSpinsBonusesStore((state) => state.bonusSystemDeclineState)
    const showFlexiIntroModal = useFreeSpinsBonusesStore((state) => state.showFlexiIntroModal)
    const selectedFlexiBonusOption = useFreeSpinsBonusesStore((state) => state.selectedFlexiBonusOption)

    const isInMainState =
        bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL ||
        bonusSystemState === BonusSystemState.MULTIPLE_BONUSES_INITIAL
    const isInDeclineState =
        bonusSystemDeclineState === BonusSystemDeclineState.SINGLE_BONUS_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.BUNDLE_DECLINE
    const isInEndState = bonusSystemState === BonusSystemState.END

    if (isInMainState && !isInDeclineState) {
        if (showFlexiBundles && showFlexiIntroModal) return <FSViewOptionsButtons bonus={bonus} />

        return (
            <FSMainButtons
                bonus={bonus}
                disablePlayNowButton={
                    showFlexiBundles &&
                    !!bonus?.flexiBonusValue &&
                    !bonus.remainingAmount &&
                    !!bonus.flexiBonusOptions &&
                    bonus.flexiBonusOptions?.length > 1 &&
                    selectedFlexiBonusOption === null
                }
            />
        )
    } else if (isInDeclineState) {
        return <FSDeclineButtons bonus={bonus} />
    } else if (isInEndState) {
        return <FSEndButtons />
    }
}

export default FSFooter
